import { useState } from "react";
import type { PetPrivateSummary } from "@/shared/contracts";
import { PetAvatar, type AvatarSurface } from "@/shared/ui";
import { sizedPhotoSrc, usePhotoSizes } from "@/shared/ui/photoSizes";

/**
 * 到访画面里的宠物：有照片用照片；没有照片、或照片加载失败时退回全站统一的头像（live 是中性爪印，演示是授权的演示小灰猫），不留空圈；
 * 来历交给头像：领养来的原创居民没照片时是居民页同一张物种插画（和地图、到家卡片一致），自己的宠物仍是爪印。
 * portraitClass 是照片的样式（店内和户外各一套）。
 * surface：头像压在什么画面上。店内画面是昼夜都不变的浅色插画，CafeScene 传 "paper"（底块、圈、爪印用纸面那套固定色，
 * 深色下不再是压在浅色画面上的深色圆块）；户外画面是用主题色画的、夜里跟着变深，OutdoorScene 不传，头像照旧跟主题走。
 * 照片缩略档（UI-PET-PHOTO-SIZES-02，10-13）：店内 82×104、户外 58（venue.css），统一按 104 取 384 那档；没有这项能力时照旧原图。
 */
export function VisitPet({ pet, portraitClass, surface }: { pet: PetPrivateSummary; portraitClass: string; surface?: AvatarSurface }) {
  const [failed, setFailed] = useState(false);
  const sized = usePhotoSizes();
  if (pet.photo_url && !failed) return <img className={portraitClass} src={sized ? sizedPhotoSrc(pet.photo_url, 104) : pet.photo_url} alt="" onError={() => setFailed(true)} />;
  return <PetAvatar petId={pet.pet_id} name={pet.name} species={pet.species} photoUrl={null} origin={pet.origin} size={58} surface={surface} />;
}
